
/**=======================================================================================================================
  *?SECTION                                                    IMPORTS
  *=======================================================================================================================**/
import client from "@/api/client";
import Vue from "vue";
import Vuex from "vuex";
import { BackgroundUpdater } from "./BackgroundUpdater";
import { ConfirmDialog } from "./ConfirmDialogStore";
import { entitycontainerstore } from "./entityContainerStore";
import { ErrorStore } from "./Error/ErrorStore";
import { JobHub } from "./Job/JobHub";
import { LookUpStore } from "./LookUpStore";
import { navstore } from "./navstore";
import { NotificationStore } from "./Notification/NotificationStore";
import { plannerstore } from "./planner";
import { prefrences } from "./prefrences";
import { triggerevents } from "./triggerevents";

import jobPlugin from "./Job/JobPlugin.js";


//!SECTION

function splitIntoRegex(string) {
  if (string) {
    string = string.replace(/\s?$/, "");
    string = string.replaceAll(" ", "|");
    var regex = new RegExp("(" + string + ")", "gi");
    return regex;
  } else {
    return string;
  }
}

const readTokenFromStorage = () => {
  try {
    return JSON.parse(localStorage.getItem("token"))
  }
  catch (error) {
    console.log("Failed to parse token", error);
    return null;
  }
}


Vue.use(Vuex);

export default new Vuex.Store({

  /**=======================================================================================================================
    *?SECTION                                                    STATE
    *=======================================================================================================================**/
  state: {
    apiRouteRoot: '/api2/ServiceProvider/',
    token: readTokenFromStorage(),
    userInfo: null,
    userInfoLoading: false,
    Version: null,
    Licences: null,
    ERPConfig: null,
    GlobalSettings: null,
    AuthorizationMatrix: null,
    FrontendConfig: null,

    clientheight: 0,

    globalSearchQuery: null, // populates from global search input

    filtersearchterm: '',
    filtersearchregex: '',
    minimizedBackgroundWork: false,
    msalConfig: {
      auth: {
        redirectUri: window.location.origin,
        clientId: 'f5a57ee5-9498-4ab3-ac67-1547f5afcc25',
        authority:
          'https://login.microsoftonline.com/organizations',
      },
      cache: {
        cacheLocation: 'localStorage',
      },
    },
    accessToken: ''
  },
  //!SECTION

  /**=======================================================================================================================
   *?SECTION                                                    MUTATIONS
   *=======================================================================================================================**/
  mutations: {
    UPDATE_TOKEN(state, response) {
      localStorage.setItem("token", JSON.stringify(response));
      state.token = response;
    },

    UPDATE_USER_INFO(state, data) {
      state.userInfo = data;
    },
    SET_USER_INFO_LOADING(state, value) {
      state.userInfoLoading = value;
      console.log("User info loading", value);
    },

    UPDATE_VERSION(state, data) {
      state.Version = data;
    },
    UPDATE_LICENCES(state, data) {
      state.Licences = data;
    },
    UPDATE_ERP_CONFIG(state, data) {
      state.ERPConfig = data;
    },
    UPDATE_GLOBAL_SETTINGS(state, data) {
      state.GlobalSettings = data;
    },
    UPDATE_AUTH_MATRIX(state, data) {
      state.AuthorizationMatrix = data;
    },
    UPDATE_FRONTEND_CONFIG(state, data) {
      state.FrontendConfig = data;
    },

    UPDATE_FILTER_SEARCH(state, update) {
      state.filtersearchterm = update;
      var regex = splitIntoRegex(update);

      state.filtersearchregex = regex;
    },
    SET_BACKGROUNDWORKMINIMIZED(state, value) {
      state.minimizedBackgroundWork = value;
    },
  },
  //!SECTION

  /**=======================================================================================================================
    *?SECTION                                                    ACTIONS
    *=======================================================================================================================**/
  actions: {
    async getSiteInfo({ state, commit, dispatch }) {
      return client()
        .get(state.apiRouteRoot + "UserInfo/SiteInfo")
        .then((response) => {
          commit("UPDATE_VERSION", response.data);
        }).catch(e => {
          dispatch('triggerevents/responseSnackbar', { response: e, method: 'getSiteInfo' });
        });
    },

    //Login
    async serviceProviderLogin({ commit, dispatch }, { username, password }) {
      var data = { grant_type: "client_credentials", scope: "ServiceProvider.Administrator" };
      var tok = username + ":" + password;
      var encUserPass = btoa(tok);

      var headers = {
        Authorization: "Basic " + encUserPass,
      };
      var http = client();
      try {
        var response = await http.post("/api2/token", data, { headers });
        commit("UPDATE_TOKEN", response.data);
        dispatch("getUserInfo");
        dispatch("prefrences/initiatePrefrences");
        dispatch("NotificationStore/connect");
        return { success: true };
      } catch (error) {
        console.log("Error response:", error.data);
        dispatch('triggerevents/responseSnackbar', { response: error.data, text: error.data?.Message ?? "Exception during login", method: 'Login', input: { username: username } });
      }
    },
    //Login
    async EntryIdLogin({ commit, dispatch }, token) {
      console.log("Login token", token)
      commit("UPDATE_TOKEN", token);
      dispatch("getUserInfo");
      dispatch("prefrences/initiatePrefrences");
      dispatch("NotificationStore/connect");
      return { success: true };
    },
    updateToken({ commit }, data) {
      commit("UPDATE_TOKEN", data);
    },

    //Log out
    logout({ commit, dispatch }) {
      commit("UPDATE_TOKEN", null);
      commit("NotificationStore/DISCONNECT", null);
      dispatch("BackgroundUpdater/StopAll");
    },

    //Get config bundle
    getUserInfo({ commit, dispatch, state }) {
      commit("SET_USER_INFO_LOADING", true);
      return client()
        .get(state.apiRouteRoot + "userinfo")
        .then((response) => {
          dispatch("parseBundle", response.data);
          commit("SET_USER_INFO_LOADING", false);
        }).
        catch(e => {
          console.error("Failed to get user info", e);
          if (e.status == 403) {
            dispatch('triggerevents/simpleChangeSuccess', { title: "Please log in again.", subtitle: "Previous login was not valid here.", icon: 'mdi-logout' });
          }
          else {
            dispatch('triggerevents/responseSnackbar', { response: e, method: 'getUserInfo' });
          }
          dispatch("logout");
        });
    },

    //Parse config bundle
    parseBundle({ commit }, bundle) {
      commit("UPDATE_USER_INFO", bundle.UserInfo);
      commit("UPDATE_VERSION", bundle.Version);
      commit("UPDATE_LICENCES", bundle.Licences);
      commit("UPDATE_ERP_CONFIG", bundle.ERPConfig);
      commit("UPDATE_GLOBAL_SETTINGS", bundle.GlobalSettings);
      commit("UPDATE_AUTH_MATRIX", bundle.AuthorizationMatrix);
      commit("UPDATE_FRONTEND_CONFIG", bundle.FrontendConfig);
    },

    updateFilterSearch({ commit }, update) {
      commit("UPDATE_FILTER_SEARCH", update);
    },
    toggleBackgroundWork({ state, commit }) {
      commit("SET_BACKGROUNDWORKMINIMIZED", !state.minimizedBackgroundWork)
    },
  },
  //!SECTION

  /**=======================================================================================================================
 *?SECTION                                                    GETTERS
 *=======================================================================================================================**/
  getters: {
    backgroundTaskCount: state => state.NotificationStore.notifications.filter(e => e.task.discreet == false).length,
    backgroundAllTaskCount: state => state.NotificationStore.notifications.length,
    taskListMinimized: state => state.minimizedBackgroundWork,
    userName: state => state.userInfo.Name,
    userInfo: state => state.userInfo,
    userInfoLoading: state => state.userInfoLoading,
    Version: state => state.Version,
    Licences: state => state.Licences,
    ERPConfig: state => state.ERPConfig,
    AuthorizationMatrix: state => state.AuthorizationMatrix,
    FrontendConfig: state => state.FrontendConfig,
    ApiRoute: (state) => (...routes) => {
      //console.log("routes", routes);
      const routing = routes.join('/');
      //console.log(state.apiRouteRoot + routing)
      return state.apiRouteRoot + routing;
    }
  },
  //!SECTION


  /**=======================================================================================================================
  *?SECTION                                                    MODULES
  *=======================================================================================================================**/
  modules: {
    triggerevents,
    navstore,
    prefrences,
    ConfirmDialog,
    JobHub,
    BackgroundUpdater,
    LookUpStore,
    plannerstore,
    NotificationStore,
    ErrorStore,
    entitycontainerstore
  },
  //!SECTION


  /**=======================================================================================================================
  *?SECTION                                                    PLUGINS
  *=======================================================================================================================**/
  plugins: [jobPlugin],
  //!SECTION
});
